<div id="content-wrapper" class="d-flex flex-column">
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid" *ngIf="isontalepgoster">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Ön Talep Listesi</h1>

      <div class="card shadow mb-4">
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Liste</h6>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <mat-table [dataSource]="listData" matSort>
              <ng-container matColumnDef="istekid">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Talep No
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.istekid }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="musteriadsoyad">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                 Talep Eden
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.musteriadsoyad }} 
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="konu">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  konu
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.konu }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="crttar">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Tarih
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.crttar  }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="servisId">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row; let element">
                   

                  <span
                    class="badge badge-warning"
                    *ngIf="element.servisId == null"
                    >Onay Bekliyor</span
                  >

                  <button
                    *ngIf="element.servisId"
                    value="res"
                    mat-icon-button
                    (click)="routerDetay(element)"
                  >
                    <mat-icon>exit_to_app</mat-icon>
                    Görüntüle
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>

              <mat-footer-row
                [ngClass]="{ hide: listData != null }"
              ></mat-footer-row>
              <mat-footer-row
                [ngClass]="{
                  hide: !(listData != null && listData.data.length == 0)
                }"
              >
              </mat-footer-row>
            </mat-table>
            <mat-paginator
              [pageSizeOptions]="[5, 10, 20]"
              [pageSize]="10"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Talep Listesi</h1>

      <div class="card shadow mb-4">
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Liste</h6>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <mat-table [dataSource]="listData2" matSort>
              <ng-container matColumnDef="Id">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Talep No
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.ServisId }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="teslimeden">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Talep Eden
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.teslimeden }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="konu">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Konu
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.talepbaslik }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="InsertDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Talep Tarihi
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.OlusturmaTarihi }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="personeladsoyad">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  İlgili Personel
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.personeladsoyad }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="kapanmatarihi">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  Solanma Tarihi
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.kapanmatarihi }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="servisId">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row; let element">
                  <button
                    value="res"
                    mat-icon-button
                    (click)="routerDetay(element)"
                  >
                    <mat-icon>exit_to_app</mat-icon>
                    {{ element.ServisDurumu }}
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns2"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns2"
              ></mat-row>

              <mat-footer-row
                [ngClass]="{ hide: listData2 != null }"
              ></mat-footer-row>
              <mat-footer-row
                [ngClass]="{
                  hide: !(listData2 != null && listData2.data.length == 0)
                }"
              >
              </mat-footer-row>
            </mat-table>
            <mat-paginator
              [pageSizeOptions]="[5, 10, 20]"
              [pageSize]="10"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
